import {
  autoSuggestionService,
  jobTitlesService,
  skillsRecommendationService,
  skillService,
} from 'services';
import { getAuthorization } from './controller';

export const location = async (search) => {
  const authorization = getAuthorization();
  const { status, data } = await autoSuggestionService(
    authorization,
    'location',
    search
  );

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  return data;
};

export const company = async (search) => {
  const authorization = getAuthorization();
  const { status, data } = await autoSuggestionService(
    authorization,
    'company',
    search
  );

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  return data;
};

export const jobTitles = async (search) => {
  const authorization = getAuthorization();
  const { status, data } = await jobTitlesService(authorization, search);

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  return data;
};

export const skillsRecommendation = async (skillsArray) => {
  const authorization = getAuthorization();
  const { status, data } = await skillsRecommendationService(
    authorization,
    skillsArray
  );

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  return data;
};

export const skills = async (search) => {
  const authorization = getAuthorization();
  const { status, data } = await skillService(authorization, search);
  if (status !== 200) {
    console.error('Error', status);
    return false;
  }

  return data;
};
